





































































import Promocode from '@/datatypes/promocode';
import PromocodeCampaign from '@/datatypes/promocode-campaign';
import PromocodeCampaignService from '@/services/promocode-campaign/PromocodeCampaignService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    promocodeCampaign: new PromocodeCampaign({}),
    redeemedPromocodes: new Array<Promocode>(),
    hasNext: true,
    errorMessage: '',
    redeemedPromocodeSearch: { term: '' as string | (string | null)[] },
    nextPointer: undefined as string | undefined,
    promocodeCampaignService: new PromocodeCampaignService(),
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      if (this.$route.query.term) {
        this.redeemedPromocodeSearch.term = this.$route.query.term;
      }

      this.getPromocodeCampaign();
    },

    getListOptions() {
      return {
        term: this.redeemedPromocodeSearch.term,
        next: this.$route.query.next,
      };
    },

    concatResponse(data: Promocode[]) {
      this.redeemedPromocodes = this.redeemedPromocodes.concat(data);
    },

    getPromocodeCampaign() {
      const promocodeCampaignId = this.$route.params.id;

      this.promocodeCampaignService.retrieve(promocodeCampaignId).then((response) => {
        this.promocodeCampaign = new PromocodeCampaign(response.data);

        this.getRedeemedPromocodes();
      });
    },

    getRedeemedPromocodes() {
      const nextPage = this.$route.query.next;

      this.promocodeCampaignService.listRedeemedCodes(
        this.$route.params.id, this.getListOptions(),
      ).then((response) => {
        this.concatResponse(response.data.map((data) => new Promocode(camelcaseKeysDeep(data))));
        if (!nextPage && this.redeemedPromocodes.length === 0) {
          this.errorMessage = 'No clients found.';
        }
        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }
        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.navigateUrl(this.nextPointer);
    },

    navigateUrl(next) {
      const query = this.getListOptions();
      query.next = next;

      this.$router.push({ query }).catch((err) => {
        if (err.name === 'NavigationDuplicated') {
          this.getRedeemedPromocodes();
        } else {
          throw err;
        }
      });
    },

    searchRedeemedPromocodes() {
      this.redeemedPromocodes = [];
      this.nextPointer = undefined;

      this.navigateUrl(undefined);
    },
  },
});
